module.exports = __webpack_public_path__ + "static/img/bg5.e69a4f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/auth/img/bg/bg5.jpg
// module id = 1209
// module chunks = 18